import { forwardRef } from 'react'
import { Link, Navigate } from 'react-router-dom'
import useIntlRoute from 'src/customHooks/useIntlRoute'

export const IntlNavigate = ({ to, ...props }: { to: string } & React.ComponentProps<typeof Navigate>) => {
  const intlRoute = useIntlRoute()
  const route = intlRoute(to)

  return <Navigate to={route} {...props} />
}

export const IntlLink = forwardRef<
  HTMLAnchorElement,
  { to: string; children?: React.ReactNode } & React.ComponentProps<typeof Link>
>(({ to, children, ...props }, ref) => {
  const intlRoute = useIntlRoute()
  const route = intlRoute(to)
  return (
    <Link to={route} ref={ref} {...props}>
      {children}
    </Link>
  )
})
